// PracticePage-v2.0.0.jsx - Version: 2.0.0 - Created: 2024-12-08
import React, { useState } from 'react'
import './PracticePage-v2.0.0.css'

const PracticePage = () => {
  const [selectedPractice, setSelectedPractice] = useState(null)
  const [dailyStreak, setDailyStreak] = useState(7)
  const [solvedToday, setSolvedToday] = useState(3)

  const practiceTypes = [
    {
      id: 'puzzles',
      title: 'پازل روزانه',
      description: 'حل پازل‌های جذاب شطرنج',
      icon: '🧩',
      color: '#4FC3F7',
      count: '۱۰ پازل جدید',
      difficulty: 'متغیر',
      time: '۱۵ دقیقه'
    },
    {
      id: 'tactics',
      title: 'تمرین تاکتیک',
      description: 'تقویت مهارت‌های تاکتیکی',
      icon: '🎯',
      color: '#81C784',
      count: '۲۵ تمرین',
      difficulty: 'متوسط',
      time: '۳۰ دقیقه'
    },
    {
      id: 'endgame',
      title: 'آموزش اندیشه',
      description: 'یادگیری پایان‌بازی‌های مهم',
      icon: '♟️',
      color: '#FFB74D',
      count: '۱۵ موقعیت',
      difficulty: 'پیشرفته',
      time: '۲۵ دقیقه'
    },
    {
      id: 'openings',
      title: 'گشایش‌ها',
      description: 'آموزش شروع‌های معروف',
      icon: '🚀',
      color: '#BA68C8',
      count: '۸ گشایش',
      difficulty: 'مبتدی',
      time: '۲۰ دقیقه'
    }
  ]

  const dailyPuzzles = [
    {
      id: 1,
      title: 'مات در ۲ حرکت',
      difficulty: 'آسان',
      points: 10,
      solved: true
    },
    {
      id: 2,
      title: 'قربانی وزیر',
      difficulty: 'متوسط',
      points: 25,
      solved: true
    },
    {
      id: 3,
      title: 'ترکیب فیلیدور',
      difficulty: 'سخت',
      points: 50,
      solved: false
    },
    {
      id: 4,
      title: 'مات پشتی',
      difficulty: 'آسان',
      points: 10,
      solved: false
    }
  ]

  const progressStats = [
    { label: 'پازل حل شده', value: '۱۲۵', change: '+۵' },
    { label: 'درصد موفقیت', value: '۷۸٪', change: '+۲٪' },
    { label: 'رتبه تاکتیکی', value: '۱۵۰۰', change: '+۲۵' },
    { label: 'مدال‌ها', value: '۸', change: '+۱' }
  ]

  const handleStartPractice = (practice) => {
    setSelectedPractice(practice)
    // اینجا می‌توانید منطق شروع تمرین را اضافه کنید
    setTimeout(() => {
      alert(`تمرین ${practice.title} شروع شد!`)
    }, 500)
  }

  const handleSolvePuzzle = (puzzleId) => {
    // منطق حل پازل
    setSolvedToday(solvedToday + 1)
    alert(`پازل حل شد! 🎉 ${dailyPuzzles.find(p => p.id === puzzleId)?.points} امتیاز دریافت کردی.`)
  }

  const renderPracticeDetail = () => {
    if (!selectedPractice) return null

    return (
      <div className="practice-detail">
        <button 
          className="back-button"
          onClick={() => setSelectedPractice(null)}
        >
          ← بازگشت به لیست تمرین‌ها
        </button>

        <div className="practice-header">
          <div className="practice-icon" style={{ backgroundColor: selectedPractice.color }}>
            {selectedPractice.icon}
          </div>
          <div className="practice-info">
            <h1>{selectedPractice.title}</h1>
            <p>{selectedPractice.description}</p>
            <div className="practice-meta">
              <span>📦 {selectedPractice.count}</span>
              <span>⚡ {selectedPractice.difficulty}</span>
              <span>⏱️ {selectedPractice.time}</span>
            </div>
          </div>
        </div>

        <div className="practice-content">
          <section className="instructions">
            <h2>📋 دستورالعمل تمرین</h2>
            <div className="instruction-steps">
              <div className="step">
                <span className="step-number">۱</span>
                <p>موقعیت شطرنج را با دقت بررسی کن</p>
              </div>
              <div className="step">
                <span className="step-number">۲</span>
                <p>بهترین حرکت ممکن را پیدا کن</p>
              </div>
              <div className="step">
                <span className="step-number">۳</span>
                <p>حرکت خودت را اجرا کن</p>
              </div>
              <div className="step">
                <span className="step-number">۴</span>
                <p>پاسخ را بررسی کن و یاد بگیر</p>
              </div>
            </div>
          </section>

          <section className="sample-puzzle">
            <h2>🎮 نمونه تمرین</h2>
            <div className="puzzle-board">
              <div className="board-placeholder">
                <p>تخته شطرنج تعاملی</p>
                <p>♜ ♞ ♝ ♛ ♚ ♝ ♞ ♜</p>
                <p>♟ ♟ ♟ ♟ · ♟ ♟ ♟</p>
                <p>· · · · · · · ·</p>
                <p>· · · · ♟ · · ·</p>
                <p>· · · · ♙ · · ·</p>
                <p>· · · · · · · ·</p>
                <p>♙ ♙ ♙ ♙ · ♙ ♙ ♙</p>
                <p>♖ ♘ ♗ ♕ ♔ ♗ ♘ ♖</p>
              </div>
              <div className="puzzle-question">
                <h3>سفید حرکت دارد. بهترین حرکت چیست؟</h3>
                <div className="puzzle-options">
                  <button className="option-button">e4-e5</button>
                  <button className="option-button">Nf3-e5</button>
                  <button className="option-button">Bc4xf7</button>
                  <button className="option-button">O-O</button>
                </div>
              </div>
            </div>
          </section>

          <div className="practice-actions">
            <button className="primary-button large">
              شروع تمرین
            </button>
          </div>
        </div>
      </div>
    )
  }

  if (selectedPractice) {
    return (
      <div className="practice-page">
        <div className="practice-container">
          {renderPracticeDetail()}
        </div>
      </div>
    )
  }

  return (
    <div className="practice-page">
      <div className="practice-container">
        <header className="practice-header">
          <h1>باشگاه تمرین</h1>
          <p>تمرین کن تا قوی‌تر بشی!</p>
        </header>

        {/* آمار روزانه */}
        <section className="daily-stats">
          <div className="streak-card">
            <div className="streak-info">
              <h3>🔥 streak روزانه</h3>
              <p>{dailyStreak} روز متوالی</p>
            </div>
            <div className="streak-count">
              {dailyStreak}
            </div>
          </div>
          
          <div className="today-stats">
            <div className="stat">
              <span className="stat-value">{solvedToday}</span>
              <span className="stat-label">حل شده امروز</span>
            </div>
            <div className="stat">
              <span className="stat-value">۳/۵</span>
              <span className="stat-label">هدف روزانه</span>
            </div>
          </div>
        </section>

        {/* پازل روزانه */}
        <section className="daily-puzzles">
          <h2>🧩 پازل‌های روزانه</h2>
          <p>حل کن، امتیاز بگیر، برنده شو!</p>
          
          <div className="puzzles-grid">
            {dailyPuzzles.map(puzzle => (
              <div key={puzzle.id} className={`puzzle-card ${puzzle.solved ? 'solved' : ''}`}>
                <div className="puzzle-header">
                  <h4>{puzzle.title}</h4>
                  <span className={`difficulty-badge ${puzzle.difficulty}`}>
                    {puzzle.difficulty}
                  </span>
                </div>
                <div className="puzzle-points">
                  🏅 {puzzle.points} امتیاز
                </div>
                <div className="puzzle-actions">
                  {puzzle.solved ? (
                    <button className="solved-button" disabled>
                      ✅ حل شده
                    </button>
                  ) : (
                    <button 
                      className="solve-button primary-button"
                      onClick={() => handleSolvePuzzle(puzzle.id)}
                    >
                      حل پازل
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* انواع تمرین‌ها */}
        <section className="practice-types">
          <h2>🎯 انواع تمرین‌ها</h2>
          <div className="practice-grid">
            {practiceTypes.map(practice => (
              <div 
                key={practice.id} 
                className="practice-card"
                onClick={() => handleStartPractice(practice)}
              >
                <div 
                  className="practice-icon"
                  style={{ backgroundColor: practice.color }}
                >
                  {practice.icon}
                </div>
                <div className="practice-content">
                  <h3>{practice.title}</h3>
                  <p>{practice.description}</p>
                  <div className="practice-meta">
                    <span>{practice.count}</span>
                    <span>⚡ {practice.difficulty}</span>
                    <span>⏱️ {practice.time}</span>
                  </div>
                </div>
                <div className="practice-arrow">→</div>
              </div>
            ))}
          </div>
        </section>

        {/* آمار پیشرفت */}
        <section className="progress-stats">
          <h2>📊 آمار پیشرفت</h2>
          <div className="stats-grid">
            {progressStats.map((stat, index) => (
              <div key={index} className="progress-card">
                <div className="progress-value">
                  {stat.value}
                  <span className="progress-change">{stat.change}</span>
                </div>
                <div className="progress-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </section>

        {/* چالش هفتگی */}
        <section className="weekly-challenge">
          <div className="challenge-card">
            <div className="challenge-header">
              <h3>🏆 چالش هفتگی</h3>
              <span className="time-left">۴ روز باقی مانده</span>
            </div>
            <p>۲۰ پازل تاکتیکی را در ۷ روز حل کن و ۲۰۰ امتیاز بگیر!</p>
            <div className="challenge-progress">
              <div className="progress-bar">
                <div className="progress-fill" style={{ width: '60%' }}></div>
              </div>
              <span>۱۲/۲۰ پازل</span>
            </div>
            <button className="primary-button">
              ادامه چالش
            </button>
          </div>
        </section>
      </div>
    </div>
  )
}

export default PracticePage